angular.module("myApp").service("Codifiers", function (uuiData, $q) {
  const setup = () => {
    const self = this

    self.kla = {
      rev_pielikuma_veids: {},
      rev_maksajuma_pielikuma_veids: {},
      rev_liguma_pielikuma_veids: {},
      rev_mervieniba: {},
      rev_liguma_veids: {},
      rev_liguma_statuss: {},
      rev_liguma_izpilditaja_veids: {},
      rev_dokumenta_statuss: {},
      rev_cfla_statuss: {},
      rev_budzeta_sadala: {},
      rev_finansejuma_avots: {},
      rev_ekspertizes: {},
      rev_ekspertizes_statuss: {},
      rev_ris3: {},
      rev_valsts_atbalsta_iemesli: {},
      statuss: {},
    }

    // biome-ignore format: keep this layout
    self.kla.choice_pielikumi = {
      // nesaimnieciski
      false: [
        { index: "1.", code: "ACK", name: "" },
        { index: "2.", code: "DIPLOMA", name: "" },
        { index: "3.", code: "CV", name: "" },
        { index: "4.", code: "PROPOSAL", name: "" },
        { index: "5.", code: "AGREEMENT", name: "" },
        { index: "6.", code: "ACK_CONFORMANCE", name: "" },
        { index: "7.", code: "ACK_POSTDOC", name: "Pēcdoktoranta mobilitātes apliecinājums un pamatojošā dokumentācija (ja attiecināms)" },
        { index: "8.", code: "FIN_OVERVIEW", name: "" },
        { index: "9.", code: "ACK_PARTNER", name: "Sadarbības partnera apliecinājums (ja attiecināms)" },
        { index: "10.", code: "ACK_FIN", name: "" },
        { index: "11.", code: "PROXY", name: "" },
        { index: "12.", code: "TRANSLATION", name: "" },
        { index: "13.", code: "AIC_CERTIFICATE", name: "" },
        { index: "14.", code: "OTHER", name: "Citi dokumenti" },
      ],
      // saimnieciski
      true: [
        { index: "1.", code: "ACK", name: "" },
        { index: "2.", code: "DIPLOMA", name: "" },
        { index: "3.", code: "CV", name: "" },
        { index: "4.", code: "PROPOSAL", name: "" },
        { index: "5.", code: "AGREEMENT", name: "" },
        { index: "6.", code: "MVK", name: "" },
        { index: "7.a", code: "VALSTS_STIM", name: "" },
        { index: "7.b", code: "VALSTS_MINIMIS", name: "" },
        { index: "8.", code: "LAST_OVERVIEW", name: "" },
        { index: "9.", code: "FIN_POL", name: "" },
        { index: "10.", code: "ACK_FIN", name: "" },
        { index: "11.", code: "PROXY", name: "" },
        { index: "12.", code: "TRANSLATION", name: "" },
        { index: "13.", code: "ACK_PARTNER", name: "" },
        { index: "14.", code: "AIC_CERTIFICATE", name: "" },
        { index: "15.", code: "OTHER", name: "" },
      ]}

    self.expert_sections = [
      // initial, midterm un final savas nianses ar reitingu un attēlojumu
      {
        key: "excellence",
        have_textarea: true,
        header: "Excellence / Scientific quality",
        intro: "intro.excellence",
        info: "info.excellence",
        rate: "number",
        types: ["INITIAL"],
      },
      {
        key: "excellence",
        have_textarea: true,
        header: "Scientific quality",
        intro: "intro.excellence",
        info: "info.mid.excellence",
        rate: "button",
        types: ["MIDTERM"],
      },
      {
        key: "excellence",
        have_textarea: true,
        header: "Excellence / Scientific quality",
        intro: "intro.excellence",
        // info: "info.excellence",
        rate: "percent",
        types: ["FINAL"],
      },
      //
      {
        key: "impact",
        have_textarea: true,
        header: "Impact / Socioeconomic impact",
        intro: "intro.impact",
        info: "info.impact",
        rate: "number",
        types: ["INITIAL"],
      },
      {
        key: "impact",
        have_textarea: true,
        header: "Socioeconomic impact",
        intro: "intro.impact",
        info: "info.mid.impact",
        rate: "button",
        types: ["MIDTERM"],
      },
      {
        key: "impact",
        have_textarea: true,
        header: "Impact / Socioeconomic impact",
        intro: "intro.impact",
        // info: "info.impact",
        rate: "percent",
        types: ["FINAL"],
      },
      //

      {
        key: "implementation",
        have_textarea: true,
        header: "Implementation / Implementation quality",
        intro: "intro.implementation",
        info: "info.implementation",
        rate: "number",
        types: ["INITIAL"],
      },
      {
        key: "implementation",
        have_textarea: true,
        header: "Implementation quality",
        intro: "intro.implementation",
        info: "info.mid.implementation",
        rate: "button",
        types: ["MIDTERM"],
      },
      {
        key: "implementation",
        have_textarea: true,
        header: "Implementation / Implementation quality",
        intro: "intro.implementation",
        // info: "info.implementation",
        rate: "percent",
        types: ["FINAL"],
      },
      //
      {
        key: "category",
        have_textarea: true,
        header: "Eligibility for research category",
        info: "info.category",
        rate: "mode",
        types: ["INITIAL"],
      },
      //
      {
        key: "overall",
        have_textarea: false,
        header: "Overall",
        rate: "button",
        consolidated_only: true,
        types: ["MIDTERM"],
      },
      {
        key: "overall",
        have_textarea: false,
        header: "Overall",
        rate: "percent",
        consolidated_only: true,
        types: ["FINAL"],
      },
    ]

    self.kla.infos = {}

    const all = {}
    const def = $q.defer()
    self.kla.$promise = def.promise

    // ir nekonsistences ar "id" / "kods" nosaukuma lietojumu
    // visi rev_* masīvi referencējas pēc *koda*
    // all[*] masīvs referencējas pēc kodifikatora ID
    //
    uuiData.list("teksti", (ts) => {
      ts.forEach((t) => {
        self.kla.infos[t.kods] = t.teksts
      })
    })
    uuiData.list("kodifikatora_ieraksts_choice", (ks) => {
      ks.forEach((k) => {
        const key = k.grupas_kods.toLowerCase()
        if (!self.kla[key]) {
          self.kla[key] = []
        }
        if (key === "pielikuma_veids") {
          // k.nosaukums = `${pielikuma_veids_idx}. ${k.nosaukums}`;
          self.kla[key].push(k)
        } else {
          self.kla[key].push(k)
        }
        all[k.id] = k.nosaukums
      })

      self.kla.ris3.forEach((p) => {
        self.kla.rev_ris3[p.kods] = p.nosaukums
      })
      self.kla.pielikuma_veids.forEach((p) => {
        self.kla.rev_pielikuma_veids[p.kods] = p.nosaukums
      })

      for (let p of self.kla.choice_pielikumi[true]) {
        if (!p.name) {
          p.name = self.kla.rev_pielikuma_veids[p.code] || p.code
        }
      }
      for (let p of self.kla.choice_pielikumi[false]) {
        if (!p.name) {
          p.name = self.kla.rev_pielikuma_veids[p.code] || p.code
        }
      }
      self.kla.maksajuma_pielikuma_veids.forEach((p) => {
        self.kla.rev_maksajuma_pielikuma_veids[p.kods] = p.nosaukums
      })
      self.kla.liguma_pielikuma_veids.forEach((p) => {
        self.kla.rev_liguma_pielikuma_veids[p.kods] = p.nosaukums
      })

      self.kla.sasniedzamo_rezultatu_mervieniba.forEach((p) => {
        self.kla.rev_mervieniba[p.kods] = p.nosaukums
      })

      self.kla.liguma_veids.forEach((p) => {
        self.kla.rev_liguma_veids[p.id] = p.nosaukums
      })
      self.kla.liguma_statuss.forEach((p) => {
        self.kla.rev_liguma_statuss[p.id] = p.nosaukums
      })
      self.kla.liguma_izpilditaja_veids.forEach((p) => {
        self.kla.rev_liguma_izpilditaja_veids[p.id] = p.nosaukums
      })
      self.kla.dokumenta_statuss.forEach((p) => {
        self.kla.rev_dokumenta_statuss[p.id] = p.nosaukums
      })
      self.kla.cfla_statuss.forEach((p) => {
        self.kla.rev_cfla_statuss[p.id] = p.nosaukums
      })

      self.kla.finansejuma_avoti.forEach((p) => {
        self.kla.rev_finansejuma_avots[p.id] = p.nosaukums
      })

      // abas budžeta sadaļas apvienotas vienā, rev_budzeta_sadala
      self.kla.budzets_generic.forEach((p) => {
        self.kla.rev_budzeta_sadala[p.id] = p.nosaukums
      })
      self.kla.budzets_saimn.forEach((p) => {
        self.kla.rev_budzeta_sadala[p.id] = p.nosaukums
      })

      self.kla.ekspertizes.forEach((p) => {
        self.kla.rev_ekspertizes[p.id] = p.nosaukums
      })

      self.kla.ekspertizes_statusi.forEach((p) => {
        self.kla.rev_ekspertizes_statuss[p.id] = p.nosaukums
      })

      self.kla.statusi.forEach((p) => {
        self.kla.statuss[p.code] = p.value
      })

      self.kla.valsts_atbalsta_iemesli.forEach((p) => {
        self.kla.rev_valsts_atbalsta_iemesli[p.code] = p.value
      })

      def.resolve(true)
    })

    self.kla.zinatnes_nozare = uuiData.list("zinatnes_nozares_list")
    self.kla.all = all

    self.kla.boolean = [
      {
        id: true,
        nosaukums: "Jā",
      },
      {
        id: false,
        nosaukums: "Nē",
      },
    ]

    self.kla.petniecibas_pieteikuma_veids = [
      {
        id: true,
        nosaukums: "Ar saimniecisko darbību saistīts",
      },
      {
        id: false,
        nosaukums: "Nav saistīts ar saimniecisko darbību",
      },
    ]
    self.kla.rev_pieteikuma_veids = {
      true: self.kla.petniecibas_pieteikuma_veids[0].nosaukums,
      false: self.kla.petniecibas_pieteikuma_veids[1].nosaukums,
      null: self.kla.petniecibas_pieteikuma_veids[1].nosaukums,
    }

    self.kla.parbaudes_veids = [
      {
        id: "PLANOTA",
        nosaukums: "Plānota pārbaude",
      },
      {
        id: "ARPUSKARTAS",
        nosaukums: "Ārpuskārtas pārbaude",
      },
    ]

    self.kla.templates = [
      {
        id: "LIGUMS",
        nosaukums: "Līgums",
      },
      {
        id: "VESTULE",
        nosaukums: "Vēstule",
      },
      {
        id: "CITS",
        nosaukums: "Cits",
      },
    ]

    self.kla.unknown = [
      {
        id: "unknown-classifier",
        nosaukums: "Nezināms klasifikators",
      },
      {
        id: "unknown_classifier",
        nosaukums: "Fixme",
      },
    ]

    self.kla.liguma_veids = [
      {
        id: "PAKALPOJUMA",
        nosaukums: "Pakalpojuma",
      },
      {
        id: "PIEGADES",
        nosaukums: "Piegādes",
      },
    ]

    self.kla.liguma_izpilditaja_veids = [
      {
        id: "DARBA_DEVEJS",
        nosaukums: "Darba devējs",
      },
      {
        id: "PARTNERIS",
        nosaukums: "Partneris",
      },
      {
        id: "CITS",
        nosaukums: "Cits",
      },
    ]

    self.kla.cfla_statuss = [
      {
        id: "NAV_IESNIEGTS",
        nosaukums: "Nav iesniegts",
      },
      {
        id: "IESNIEGTS",
        nosaukums: "Iesniegts",
      },
      {
        id: "APSTIPRINATS",
        nosaukums: "Apstiprināts",
      },
    ]

    self.kla.liguma_statuss = [
      {
        id: "PLANOTS",
        nosaukums: "Plānots",
      },
      {
        id: "PROCESA",
        nosaukums: "Procesā",
      },
      {
        id: "IZPILDITS",
        nosaukums: "Izpildīts",
      },
      {
        id: "LAUZTS",
        nosaukums: "Lauzts",
      },
    ]

    self.kla.uzraudzibas_dokumentu_grupas = [
      {
        id: "RISKU-IZVERTEJUMS",
        nosaukums: "Risku izvērtējumu pārbaudes lapas",
      },
      {
        id: "MP-PARBAUDE",
        nosaukums: "MP pārbaudes lapas",
      },
      {
        id: "GROZIJUMI",
        nosaukums: "Grozījumu pārbaudes lapas",
      },
      {
        id: "PECUZRAUDZIBA",
        nosaukums: "Pēcuzraudziba",
      },
      {
        id: "RIKOJUMI",
        nosaukums: "Maksājumu rīkojumi",
      },
      {
        id: "CITS",
        nosaukums: "Citi dokumenti",
      },
    ]

    self.kla.ekspertize_rate_eng = {
      YES: "Complies",
      NO: "Does not comply",
      COND: "Complies, with recommendations",
    }

    self.kla.eksperta_statuss_eng = {
      null: "Not yet started",
      MELNRAKSTS: "In progress",
      IESNIEDZAMS: "Ready to submit",
      IESNIEGTS: "Submitted",
    }

    self.kla.dokumenta_statuss = [
      { id: "MELNRAKSTS", nosaukums: "Melnraksts" },
      { id: "AKTUALS", nosaukums: "Publicēts" },
      { id: "NEAKTUALS", nosaukums: "Neaktuāls" },
    ]

    self.kla.mp_pieprasijuma_veids = [
      { id: "STARPPOSMA", nosaukums: "Starpposma" },
      { id: "NOSLEGUMA", nosaukums: "Noslēguma" },
    ]

    self.kla.rev_mp_pieprasijuma_veids = {
      STARPPOSMA: "Starpposma",
      NOSLEGUMA: "Noslēguma",
    }

    self.kla.mp_riska_statuss = [
      { id: "NAV_NOVERSTS", nosaukums: "Nav novērsts" },
      { id: "RISINASANA", nosaukums: "Risināšanā" },
      { id: "IR_NOVERSTS", nosaukums: "Ir novērsts" },
    ]

    self.kla.rev_mp_riska_statuss = {
      NAV_NOVERSTS: "Nav novērsts",
      RISINASANA: "Risināšanā",
      IR_NOVERSTS: "Ir novērsts",
    }

    self.kla.lomas = {
      DARBINIEKS: "Darbinieks",
      POSTDOC: "Postdoc",
      IESNIEDZEJS: "Iesniedzējs",
    }

    self.kla.bool = {
      true: "Jā",
      false: "Nē",
      null: "Nē",
    }

    self.kla.statusi = [
      { code: "MELNRAKSTS", value: "Melnraksts" },
      { code: "MELNRAKSTS-LABOJUMS", value: "Labojuma melnraksts" },
      { code: "MELNRAKSTS-VIDUSPOSMS", value: "Vidusposms, sagatavošanā" },
      { code: "NEAKTUALS", value: "Precizēts" },
      { code: "PROMOTED", value: "Pārcelts uz pilno plūsmu" },
      { code: "IESNIEGTS", value: "Iesniegts" },
      { code: "NORAIDITS", value: "Noraidīts" },
      // { code: "DZESTS", value: 'XXX Dzēsts XXX' },
      { code: "IZSKATITS", value: "Izskatīts" },
      { code: "APSTIPRINATS", value: "Apstiprināts" },
      { code: "SAMAKSATS", value: "Samaksāts" },
      { code: "LZP_OK", value: "LZP apstipr." },
      { code: "MP_NORAIDITS", value: "MP noraidīts" },
      { code: "IZSKATISANA", value: "Izskatīšanā" },
      { code: "NETIKS-ISTENOTS", value: "Netiks īstenots" },
      { code: "TEHNISKIE", value: "Tehniskie labojumi" },
    ]

    self.kla.valsts_atbalsta_iemesli = [
      { code: "EK", value: "Eiropas Komisijas Regula Nr. 651/2014" },
      { code: "MINIMIS", value: "Eiropas Komisijas Regula Nr. 2023/2831 par de minimis atbalstu" },
      { code: "NA", value: "Nav attiecināms" },
    ]

    self.kla.budzeta_sadalas_saimniecisks = [
      // vēsturiski duplicēts ar kla.budzets_saimn, viņiem jābūt vienādiem
      {
        id: "pers",
        sadala: "1",
        is_major: true,
        nosaukums: "1. Pētniecības pieteikuma īstenošanas personāla atlīdzības izmaksas",
      },
      {
        id: "pers_pdalga",
        nosaukums: "1.1. Pēcdoktoranta alga",
      },
      {
        id: "pers_alga",
        nosaukums: "1.2 Pētnieku, tehnisko un palīgdarbinieku algas",
      },
      {
        id: "isten",
        sadala: "2",
        is_major: true,
        nosaukums: "2. Pētniecības pieteikuma īstenošanas izmaksas",
      },
      {
        id: "isten_mat",
        nosaukums: "2.1 Materiālu un izejvielu izmaksas",
      },
      {
        id: "isten_outsource",
        nosaukums: "2.2 Ārpakalpojumi",
      },
      {
        id: "isten_instrum",
        nosaukums: "2.3 Instrumentu un aprīkojuma izmaksas",
      },
      {
        id: "isten_komandejumi",
        nosaukums: "2.4 Komandējumi un darba braucieni",
      },
      {
        id: "macibas",
        sadala: "3",
        is_major: true,
        nosaukums: "3. Mācības",
      },
      {
        id: "legal",
        sadala: "4",
        is_major: true,
        nosaukums: "4. Izmaksas par tehnoloģiju tiesību aizsardzību",
      },
    ]

    // nesaimnieciskiais
    self.kla.budzets_generic = [
      {
        id: "pers",
        sadala: "1",
        is_major: true,
        nosaukums: "Pētniecības pieteikuma īstenošanas personāla atlīdzības izmaksas",
      },
      { id: "isten", sadala: "2", is_major: true, nosaukums: "Pētniecības pieteikuma īstenošanas izmaksas" },
      {
        id: "admin",
        sadala: "3",
        is_major: true,
        nosaukums: "Pētniecības pieteikuma administrēšanas un infrastruktūras uzturēšanas izmaksas",
      },
      { id: "nat", sadala: "4", is_major: true, nosaukums: "Ieguldījums natūrā" },
      { id: "nat_pamatl", sadala: "4.1", nosaukums: "Pamatlīdzekļi (materiāli aktīvi)" },
      { id: "nat_mater", sadala: "4.2", nosaukums: "Piešķirtie materiāli (materiālie aktīvi)" },
      {
        id: "nat_darbibas",
        sadala: "4.3",
        nosaukums: "Pētniecības pieteikuma īstenošanas personāla atlīdzības izmaksas",
      },
      { id: "mob", sadala: "", is_major: true, nosaukums: "Ārvalstu mobilitāte" },
      { id: "mob_fam", sadala: "", is_major: true, nosaukums: "Ģimenes pabalsts mobilitātes laikā" },
      { id: "mob_postdoc", sadala: "", is_major: true, nosaukums: "Pēcdoktoranta pārcelšanās atbalsts" },
      { id: "fam_move", sadala: "", is_major: true, nosaukums: "Ģimenes pabalsts pārcelšanās gadījumā" },
    ]

    self.kla.budzets_saimn = [
      // duplicēts ar budzeta_sadalas_saimniecisks
      // ja starp šiem ir atšķirības, tad tas ir bugs: šo derētu likvidēt
      {
        id: "pers",
        sadala: "1",
        nosaukums: "Pētniecības pieteikuma īstenošanas personāla atlīdzības izmaksas",
      },
      {
        id: "pers_pdalga",
        sadala: "1.1",
        nosaukums: "Pēcdoktoranta alga (bruto + darba devēja sociālās apdrošināšanas obligātās iemaksas)",
      },
      {
        id: "pers_alga",
        sadala: "1.2",
        nosaukums:
          "Pētnieku, tehnisko un palīgdarbinieku algas (bruto + darba devēja sociālās apdrošināšanas obligātās iemaksas)",
      },
      { id: "isten", sadala: "2", nosaukums: "Pētniecības pieteikuma īstenošanas izmaksas" },
      {
        id: "isten_mat",
        sadala: "2.1",
        nosaukums:
          "Materiālu un izejvielu izmaksas, kas radušās tieši pētniecības pieteikuma īstenošanās rezultātā",
      },
      {
        id: "isten_outsource",
        sadala: "2.2",
        nosaukums:
          "Ārpakalpojumi. Izmaksas par līgumpētījumiem, zināšanām un patentiem, un citiem pakalpojumiem, kas izmantoti vienīgi pētniecības pieteikuma mērķiem.",
      },
      {
        id: "isten_instrum",
        sadala: "2.3",
        nosaukums:
          "Pētniecības pieteikuma instrumentu un aprīkojuma izmaksas, ciktāl un cik ilgi tos izmanto pētniecības pieteikuma īstenošanā",
      },
      { id: "isten_komandejumi", sadala: "2.4", nosaukums: "Komandējumi un darba braucieni" },
      { id: "isten_citi", sadala: "2.5", nosaukums: "Citas pētniecības pieteikuma īstenošanas izmaksas" },
      { id: "macibas", sadala: "3", nosaukums: "Mācības" },
      {
        id: "legal",
        sadala: "4",
        nosaukums: "Izmaksas par tehnoloģiju tiesību aizsardzību (ja attiecināms)",
      },
    ]

    self.kla.finansejuma_avoti = [
      { id: "eraf", nosaukums: "1. Eiropas Reģionālās attīstības fonda finansējums" },
      { id: "budget", nosaukums: "2. Attiecināmais valsts budžeta finansējums" },
      { id: "other", nosaukums: "3. Citi finansēšanas resursi" },
      // { id: "other_saimn", nosaukums: "3.1 Saimnieciskā darbība" },
      // { id: "other_cred", nosaukums: "3.2 Kredītresursi" },
      // { id: "other_nat", nosaukums: "3.3 Ieguldījums natūrā" },
      // { id: "other_nat_pamatl", nosaukums: "3.3.1 Pamatlīdzekļi (materiālie aktīvi)" },
      // { id: "other_nat_mater", nosaukums: "3.3.2 piešķirtie materiāli (materiālie aktīvi)" },
      // { id: "other_nat_darbibas", nosaukums: "3.3.3 ar pētniecību saistītās profesionālās darbības" },
      // { id: "other_custom", nosaukums: "3.4 citi" },
    ]

    self.kla.saimn_finansejuma_avoti = [
      // { id: "total_attiec", nosaukums: "Kopējās attiecināmās izmaksas" },
      { id: "total_eraf", nosaukums: "Kopējais ERAF attiecināmais finansējums" },
      { id: "total_priv", nosaukums: "Kopējais privātais finansējums" },
      // { id: "petnieciba", nosaukums: "Pētniecība" },
      // { id: "petnieciba_eraf", nosaukums: "- ERAF attiecināmais finansējums" },
      // { id: "petnieciba_priv", nosaukums: "- Privātais finansējums" },
      // { id: "tehnol", nosaukums: "Tehnoloģiju tiesību aizsardzība" },
      // { id: "tehnol_eraf", nosaukums: "- ERAF attiecināmais finansējums" },
      // { id: "tehnol_priv", nosaukums: "- Privātais finansējums" },
    ]

    self.kla.ekspertizes = [
      { id: "LZP", nosaukums: "LZP ekspertīze (vecais)" },
      { id: "LZP.NP", nosaukums: "LZP: Nepapildināmie kritēriji" },
      { id: "LZP.PP", nosaukums: "LZP: Papildināmie kritēriji" },
      { id: "INITIAL", nosaukums: "Sākotnējā ekspertīze" },
      { id: "MIDTERM", nosaukums: "Vidusposma ekspertīze" },
      { id: "FINAL", nosaukums: "Gala ekspertīze" },
    ]

    self.kla.ekspertizes_statusi = [
      { id: "MELNRAKSTS", nosaukums: "Melnraksts" },
      { id: "AKCEPTETS", nosaukums: "Apstiprināts" },
      { id: "VAR-IESNIEGT", nosaukums: "Iesniedzams" },
      { id: "IESNIEGTS", nosaukums: "Iesniegts" },
      { id: "VAR-NORAIDIT", nosaukums: "Noraidāms" },
      { id: "NORAIDITS", nosaukums: "Noraidīts" },
      { id: "SASKANOSANA", nosaukums: "Saskaņošanā" },
    ]

    self.kla.default_measures = {
      // Pēcdoktoranta ārvalstu mobilitāte vismaz 6 mēneši
      mob: [710, 6],
      // Ģimenes pabalsts mobilitātes laikā
      mob_fam: [660, 6],
      // Pēcdoktoranta pārcelšanās atbalsts
      mob_postdoc: [710, 1],
      // Ģimenes pabalsts pārcelšanās gadījumā
      fam_move: [660, 1],
      isten: [1000, null],
      pers: [3860, null],
    }

    self.kla.mp_tabs = [
      {
        only_manager: true,
        name: "lzp-meta",
        section: "",
        head: "LZP",
        template: "pages/mp/tab-lzp-meta.html",
      },
      {
        name: "maindata",
        section: "1",
        head: "Pieteikums",
        template: "pages/mp/tab-maindata.html",
      },
      {
        name: "istenosana",
        section: "2",
        head: "Īstenošana",
        template: "pages/mp/tab-istenosana.html",
      },
      {
        name: "iznakumi",
        section: "3",
        head: "Iznākuma rādītāji",
        template: "pages/mp/tab-iznakuma-raditaji.html",
      },

      {
        name: "istenosana_problemas",
        section: "4",
        head: "Īstenošanas problēmas",
        template: "pages/mp/tab-istenosana-problemas.html",
      },

      {
        name: "publicitate",
        section: "5",
        head: "Publicitāte",
        template: "pages/mp/tab-publicitate.html",
      },
      {
        name: "darba_ligumi",
        section: "6",
        head: "Darba līgumi",
        template: "pages/mp/tab-darba-ligumi.html",
      },
      {
        name: "iep_ligumi",
        konkurss: ["1.1.1.2"],
        section: "6.1",
        head: "Iepirkuma līgumi",
        template: "pages/mp/tab-iepirkuma-ligumi.html",
      },
      {
        obsolete: true,
        // attēlots readonly, ja mp.citi_ligumi != null
        name: "citi_ligumi",
        section: "6.2",
        head: "Citi līgumi",
        template: "pages/mp/tab-citi-ligumi.html",
        visible_fn: (dto) => dto.citi_ligumi?.length > 0,
      },
      {
        name: "rezultati",
        konkurss: ["1.1.1.2"],
        section: "7.4",
        head: "Rezultāta rādītāji",
        template: "pages/mp/tab-rezultata-raditaji.html",
      },
      {
        name: "rezultati",
        section: "7",
        visible_fn: (dto) => dto.pieprasijuma_veids === "NOSLEGUMA",
        head: "Mērķu sasniegšana",
        template: "pages/mp/tab-merkis.html",
      },
      {
        name: "izdevumi",
        section: "8.1",
        head: "Izdevumus pamatojošie dokumenti",
        template: "pages/mp/tab-izdevumi-saimn.html",
        visible_fn: (dto) => dto.ar_saimniecisku_darbibu_saistits === true,
      },
      {
        name: "izdevumi",
        section: "8.1",
        head: "Izdevumus pamatojošie dokumenti",
        template: "pages/mp/tab-izdevumi-nesaimn.html",
        visible_fn: (dto) => dto.ar_saimniecisku_darbibu_saistits === false,
      },
      {
        name: "sl-izdevumi",
        section: "8.2",
        head: "Vienības izmaksas standarta likmes izdevumi",
        template: "pages/mp/tab-std-izdevumi.html",
        visible_fn: (dto) => dto.ar_saimniecisku_darbibu_saistits === false,
      },
      {
        name: "natura",
        section: "8.4",
        head: "Ieguldījumi natūrā",
        template: "pages/mp/tab-natura.html",
        visible_fn: (dto) => dto.ar_saimniecisku_darbibu_saistits === false,
      },
      {
        name: "kopsavilkums",
        section: "9",
        head: "Kopsavilkums",
        template: "pages/mp/tab-kopsavilkums.html",
      },
      {
        name: "pielikumi.darba_laiks",
        section: "",
        icon: "attachment",
        attachment_type: "MP_DARBA_LAIKS",
        head: "Darba laika uzskaite",
        template: "pages/mp/tab-pielikumi.html",
      },
      {
        deprecated: true,
        visible_fn: (dto) => dto.pielikumi.find((p) => p.pielikuma_veids === "MP_PAVEIKTAIS_DARBS"),
        name: "pielikumi.paveiktais_darbs",
        section: "",
        icon: "attachment",
        attachment_type: "MP_PAVEIKTAIS_DARBS",
        head: "Paveiktā darba uzskaite",
        template: "pages/mp/tab-pielikumi.html",
      },
      {
        name: "pielikumi.iepirkums",
        icon: "attachment",
        section: "",
        head: "Iepirkumi",
        attachment_type: "MP_IEPIRKUMS",
        template: "pages/mp/tab-pielikumi.html",
        visible_fn: (dto) => dto.ar_saimniecisku_darbibu_saistits,
      },
      {
        deprecated: true,
        visible_fn: (dto) => dto.pielikumi.find((p) => p.pielikuma_veids === "MP_POP_PARSKATS"),
        name: "pielikumi.pop_parskats",
        icon: "attachment",
        section: "",
        head: "Populārzinātniskie pārskati",
        attachment_type: "MP_POP_PARSKATS",
        template: "pages/mp/tab-pielikumi.html",
      },
      {
        name: "pielikumi.blakus_ligums",
        icon: "attachment",
        section: "",
        head: "Darba līgumi",
        attachment_type: "MP_BLAKUS_LIGUMS",
        template: "pages/mp/tab-pielikumi.html",
      },
      {
        name: "pielikumi.izdevuma_dok",
        icon: "attachment",
        section: "",
        head: "Izdevumu dok.",
        attachment_type: "MP_IZDEVUMA_DOK",
        template: "pages/mp/tab-pielikumi.html",
      },
      {
        name: "pielikumi.rezultatu_dok",
        icon: "attachment",
        section: "",
        head: "Rezultātu dok.",
        attachment_type: "MP_REZULTATU_DOK",
        template: "pages/mp/tab-pielikumi.html",
      },
      {
        name: "pielikumi.pvn_parskats",
        icon: "attachment",
        section: "",
        head: "PVN pārskats",
        attachment_type: "MP_PVN_PARSKATS",
        template: "pages/mp/tab-pielikumi.html",
        visible_fn: (dto) => dto.ar_saimniecisku_darbibu_saistits,
      },
      {
        name: "pielikumi.gramatvediba",
        icon: "attachment",
        section: "",
        head: "Grāmatvedības organizācija",
        attachment_type: "MP_GRAM_APRAKSTS",
        template: "pages/mp/tab-pielikumi.html",
      },
      {
        name: "pielikumi.nomenklatura",
        icon: "attachment",
        section: "",
        head: "Lietu nomenklatūra",
        attachment_type: "MP_NOMENKLATURA",
        template: "pages/mp/tab-pielikumi.html",
      },
      {
        name: "pielikumi.citi",
        icon: "attachment",
        section: "",
        head: "Citi pielikumi",
        attachment_type: "MP_CITS",
        template: "pages/mp/tab-pielikumi.html",
      },
      {
        name: "pielikumi.uzraudziba",
        only_manager: true,
        section: "",
        head: "Uzraudzības dokumenti",
        template: "pages/mp/tab-uzraudziba.html",
      },
      {
        name: "history",
        only_admin: true,
        section: "",
        head: "Statusu vēsture",
        template: "pages/mp/tab-statusu-vesture.html",
      },
    ]

    self.kla.pp_tabs = [
      {
        only_manager: true,
        name: "lzp-meta",
        section: "",
        head: "LZP",
        template: "pages/pp/tab-lzp-meta.html",
      },

      {
        only_manager: true,
        name: "parbaudes",
        section: "",
        head: "Pārbaudes",
        template: "pages/pp/tab-parbaudes.html",
      },

      {
        name: "maindata",
        section: "",
        head: "Iesniegums",
        template: "pages/pp/tab-maindata.html",
        flows: ["default", "compact"],
      },
      {
        name: "apraksts",
        section: "1.",
        head: "Apraksts",
        template: "pages/pp/tab-apraksts.html",
        flows: ["default"],
      },
      {
        name: "rezultati",
        section: "1.5",
        head: "Rezultāti",
        template: "pages/pp/tab-rezultati.html",
        flows: ["default"],
      },
      {
        name: "raditaji",
        section: "1.6",
        head: "Rādītāji",
        template: "pages/pp/tab-raditaji.html",
        flows: ["default", "compact.nesaimn"],
      },
      {
        name: "mobilitate-nesaimn-compact",
        head: "Mobilitāte",
        template: "pages/pp/tab-mobilitate-compact-n.html",
        flows: ["compact.nesaimn"],
      },
      {
        name: "istenosanas_vietas",
        section: "1.7",
        head: "Īstenošanas vietas",
        template: "pages/pp/tab-istenosanas-vietas.html",
        flows: ["default"],
      },
      {
        name: "partneri",
        section: "1.9",
        head: "Partneri",
        template: "pages/pp/tab-partneri.html",
        flows: ["default", "compact.nesaimn"],
      },
      {
        name: "istenosana",
        section: "2.",
        head: "Īstenošana",
        template: "pages/pp/tab-istenosana.html",
        flows: ["default"],
      },
      {
        name: "riski",
        section: "2.4",
        head: "Risku izvērtējums",
        template: "pages/pp/tab-riski.html",
        flows: ["default"],
      },
      {
        name: "projekti",
        section: "2.5",
        head: "Saistītie projekti",
        template: "pages/pp/tab-projekti.html",
        visible_fn: (dto) => dto.karta.ir_sadala_25,
        flows: ["default"],
      },
      {
        name: "uzturesana",
        section: "3.",
        head: "Uzturēšana",
        template: "pages/pp/tab-uzturesana.html",
        flows: ["default"],
      },
      {
        name: "publicitate",
        section: "5",
        head: "Publicitāte",
        template: "pages/pp/tab-publicitate.html",
        flows: ["default"],
      },
      {
        name: "valsts",
        section: "7.",
        konkurss: ["1.1.1.2"],
        head: "Valsts atbalsta jautājumi",
        template: "pages/pp/tab-valsts-pre-19.html",
        flows: ["default"],
      },
      {
        name: "valsts",
        section: "7.",
        konkurss: ["1.1.1.9"],
        head: "Valsts atbalsts",
        template: "pages/pp/tab-valsts.html",
        flows: ["default", "compact.saimn"],
      },

      {
        name: "laika_grafiks",
        section: "8.",
        head: "Laika grafiks",
        template: "pages/pp/tab-laika-grafiks.html",
        flows: ["default"],
      },
      {
        name: "budzets",
        section: "",
        head: "Budžeta kopsavilkums",
        template: "pages/pp/tab-budzets-saimn.html",
        visible_fn: (dto) => dto.ar_saimniecisku_darbibu_saistits,
        flows: ["default"],
      },
      {
        name: "finplans-saimn",
        visible_fn: (dto) => dto.ar_saimniecisku_darbibu_saistits,
        section: "9.2",
        head: "Finansējuma plāns",
        template: "pages/pp/tab-saimnfinplans.html",
        flows: ["default"],
      },
      {
        name: "budzets-saimn",
        visible_fn: (dto) => dto.ar_saimniecisku_darbibu_saistits,
        section: "",
        head: "Finansējuma plāns",
        template: "pages/pp/tab-finplans-saimn.html",
        flows: ["default"],
      },
      {
        name: "finplans-nesaimn",
        visible_fn: (dto) => !dto.ar_saimniecisku_darbibu_saistits,
        section: "9.",
        head: "Finansējuma plāns",
        template: "pages/pp/tab-finplans-nesaimn.html",
        flows: ["default"],
      },
      {
        name: "budzets-nesaimn",
        section: "10.",
        visible_fn: (dto) => !dto.ar_saimniecisku_darbibu_saistits,
        head: "Budžeta kopsavilkums",
        template: "pages/pp/tab-budzets-nesaimn.html",
        flows: ["default"],
      },
      {
        name: "attachments",
        section: "",
        head: "Pielikumi",
        template: "pages/pp/tab-attachments.html",
        flows: ["default"],
      },
      {
        name: "attachments-compact",
        section: "",
        head: "Pielikumi",
        template: "pages/pp/tab-attachments-compact.html",
        flows: ["compact"],
      },
      {
        name: "attachments-compact-lzp-view",
        section: "",
        head: "Pielikumi (pilnais skats)",
        template: "pages/pp/tab-attachments.html",
        visible_fn: (_dto, user) => user.is.manager,
        flows: ["compact"],
      },
      {
        name: "history",
        only_manager: true,
        section: "",
        head: "Statusu vēsture",
        template: "pages/pp/tab-history.html",
        never_lock: true,
      },
      {
        only_manager: true,
        name: "lzp-pielikumi",
        visible: false,
        section: "",
        head: "Vērtēšanas pielikumi",
        template: "pages/pp/tab-lzp-pielikumi.html",
      },
      {
        only_manager: true,
        name: "ekspertu-vertejums",
        visible: false,
        section: "",
        head: "Ekspertu vērtējums",
        template: "pages/pp/tab-ekspertu-vertejums.html",
      },
      {
        only_manager: true,
        name: "risku-izvertejums",
        visible: false,
        section: "",
        head: "Risku izvērtējums",
        template: "pages/pp/tab-risku-izvertejums.html",
      },
      {
        name: "vestules",
        visible: false,
        never_lock: true,
        section: "",
        head: "Vēstules un līgumi",
        template: "pages/pp/tab-ligumi.html",
        flows: ["default"],
      },
      {
        name: "pielikumi.uzraudziba",
        only_manager: true,
        section: "",
        head: "Uzraudzības dokumenti",
        template: "pages/mp/tab-uzraudziba.html", // sic: MP
        flows: ["default"],
      },
      {
        name: "vidusposms",
        section: "",
        head: "Vidusposma atskaite",
        template: "pages/pp/tab-vidusposma-atskaite.html",
        never_lock: true,
        flows: ["default"],
      },
      {
        name: "galaposms",
        section: "",
        head: "Gala atskaite",
        template: "pages/pp/tab-galaposma-atskaite.html",
        never_lock: true,
        flows: ["default"],
      },
      {
        only_manager: true,
        name: "pieeja",
        visible: true,
        section: "",
        head: "Postdoktorantu pieeja",
        template: "pages/pp/tab-pieeja.html",
      },
      {
        name: "maksajumu-grafiks",
        section: "",
        never_lock: true,
        head: "Maksājumu pieprasījumu grafiks",
        template: "pages/pp/tab-maksajumu-grafiks.html",
        flows: ["default"],
      },
    ]

    let sabloni_promise
    self.sabloni = () => {
      if (sabloni_promise === undefined) {
        sabloni_promise = uuiData.list("sablons_choice")
      }
      return sabloni_promise
    }

    let kriteriji_promise

    const version_compare = (va, vb) => {
      const as = va.split(/[_]/)
      const bs = vb.split(/[_]/)
      const A_FIRST = -1
      const B_FIRST = 1
      for (let i = 0; i < Math.max(as.length, bs.length); i++) {
        const a = as[i] || ""
        const b = bs[i] || ""

        const ia = +a
        const ib = +b

        if (a === b) continue
        if (ia && ib) {
          // numeric comparison
          return ia > ib ? B_FIRST : A_FIRST
        }
        if (ia && !ib) {
          return B_FIRST
        }
        if (!ia && ib) {
          return A_FIRST
        }
        if (!ia && !ib) {
          // string comparison
          return a.localeCompare(b)
        }
      }
      return 0
    }

    const kriteriji_sort = (ka, kb) => {
      const a = ka.kriterija_kods
      const b = kb.kriterija_kods
      const res = version_compare(a, b)
      return res
    }

    self.kriteriji = () => {
      if (kriteriji_promise === undefined) {
        kriteriji_promise = uuiData.list("definetie_kriteriji_visi", (ks) => {
          const l = ks.map((k) => ({
            ...k,
            opcijas_json: k.opcijas_json ? JSON.parse(k.opcijas_json) : {},
          }))
          l.sort(kriteriji_sort)
          return l
        })
      }
      return kriteriji_promise
    }

    return self
  }

  setup()

  return this
})
